module.exports = __webpack_public_path__ + "img/empty.1776c107.png";